import {preloader} from '../utils/utils';

var activeFilters = {};
var preloaderDOM;
var itemDOM;
var baseHref;
export default function BlockAsariOffers() {

  itemDOM = document.querySelector( '.asari-offers.loading .ajax-content' );
  if (!itemDOM) {
    return;
  }
  baseHref = document.querySelector('.block-asari-offers .base-href').value;
  preloaderDOM = document.querySelector( '.asari-offers .preloader' );

  if (itemDOM.innerHTML !== '') {
    preloader( false, preloaderDOM );
    return true;
  }

  parseHrefFilter();
  loadOffers( itemDOM, preloaderDOM );
  searchForm();

}

const loadOffers = function( itemDOM, preloaderDOM ) {
  console.log( 'loadOffers' );
  let xhr = new XMLHttpRequest();
  xhr.open( 'POST', '/wp/wp-admin/admin-ajax.php' );
  //xhr.responseType = 'json';
  xhr.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded;' );
  xhr.send(
      'action=block_list_offers&filters=' + JSON.stringify( activeFilters ) + '&base_url=' + JSON.stringify(baseHref));
  xhr.onload = function() {
    if (xhr.status != 200) {
      console.error( `Error ${xhr.status}: ${xhr.statusText}` ); // e.g. 404: Not Found
    } else {
      itemDOM.innerHTML = xhr.responseText;
      document.querySelector('.offers-count').innerHTML =  '('+document.querySelector('.offers[data-offers_count]').dataset.offers_count + ' oferty)';
      setTimeout( function() {
        preloader( false, preloaderDOM );
        itemDOM.classList.remove( 'loading' );
        itemDOM.classList.add( 'ready' );
        setUrl();
      }, 25 );
    }
  };
  xhr.onerror = function() {
    console.log( 'Request failed' );
  };
};

const parseHrefFilter = function() {
  let searchParams = new URLSearchParams( document.location.search );
  for (let p of searchParams) {
    activeFilters[p[0]] = p[1];
  }
};

const searchForm = function() {
  var searchForm = document.querySelector( '.search-form' );
  var buttonSubmit = searchForm.querySelector( 'button:not([type="submit"])' );

  buttonSubmit.addEventListener( 'click', function( e ) {

    console.log( 'search click!' );
    preloader( true, preloaderDOM );
    itemDOM.innerHTML = '';
    activeFilters = {};
    var formFields = searchForm.querySelectorAll( 'select,input' );
    formFields.forEach( function( formField ) {
      if (formField.value.trim() == '') {
      } else {
        activeFilters[formField.getAttribute('name')] = formField.value;
      }
    } );
    loadOffers(itemDOM,preloaderDOM);
  } );
};


const setUrl = function () {
  let href = baseHref;
  let searchParams = new URLSearchParams();
  Object.keys(activeFilters).forEach(function (key) {
    if (activeFilters[key].length > 0) {
      searchParams.append(key,activeFilters[key]);
    }
  });
  if(searchParams.toString().length > 0) {
    href = baseHref + '?' + searchParams.toString();
  }
  window.history.pushState({}, null, href);
};